var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact-informations container" }, [
    _c("h2", [_vm._v(_vm._s(_vm.heading))]),
    _c(
      "p",
      {
        staticClass:
          "contact-informations__paragraph paragraph paragraph--large"
      },
      [_vm._v(_vm._s(_vm.paragraph))]
    ),
    _c("div", { staticClass: "contact-informations__info" }, [
      _c(
        "a",
        {
          staticClass: "contact-informations__email",
          attrs: { href: _vm.link }
        },
        [_c("span", [_vm._v(_vm._s(_vm.email))])]
      ),
      _c("span", { staticClass: "contact-informations__spacing" }, [
        _vm._v("|")
      ]),
      _c("span", { staticClass: "contact-informations__phone" }, [
        _vm._v(_vm._s(_vm.phone))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }